import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MediaBankFileModel } from '../media-bank-file.model';
import { FileTypeService } from '@fi-shared/fi-shared-services/file-type.service';
import { FiImageSize } from '@fi-shared/types/image-size';
import { StatusCodeType } from '@fi-shared/types/status-code-type';
import { AppTextService } from '@fi-shared/app-text';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { fiGetMediaBankFileIcon } from '@fi-shared/utils';
import { ActionFailureReasonCode } from '@fi-shared/types/action-failed-reason-code';

@Component({
    selector: 'fi-media-bank-file-upload-detail',
    templateUrl: './media-bank-file-upload-detail.component.html',
    styleUrls: ['./media-bank-file-upload-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-media-bank-file-upload-detail' },
    standalone: false,
})
export class MediaBankFileUploadDetailComponent {
    @Input() mediaBankFile: MediaBankFileModel;
    @Input() displayName: string;
    @Input() showDelete: boolean;
    @Input() showEdit: boolean;
    @Input() reasonCode: ActionFailureReasonCode;
    @Output() deleteFunction = new EventEmitter();
    @Output() editFunction = new EventEmitter();

    StatusCodeType = StatusCodeType;
    isErrorHidden = true;

    constructor(
        private appTextService: AppTextService,
        private fileTypeService: FileTypeService,
        private mediaStorageService: FiMediaStorageService,
    ) {}

    GetMediaBankFileIcon() {
        return (
            'fa-regular fa-lg ' + fiGetMediaBankFileIcon(this.mediaBankFile ? this.mediaBankFile.FileType : undefined)
        );
    }

    GetFileUploadLimit() {
        let fileName = '';
        if (this.mediaBankFile) fileName = this.mediaBankFile.Name + this.mediaBankFile.Extension;

        return this.fileTypeService.getFileUploadLimit(fileName);
    }

    isFileUploadLimitExceed() {
        return this?.reasonCode === ActionFailureReasonCode.MediaBank_FileSizeLimitExceeded;
    }

    formatError(errorCode, fileUploadLimit) {
        const formatArguments = arguments;
        formatArguments[0] = this.appTextService.get(errorCode);
        return String.format.apply(this, formatArguments);
    }

    deleteMediaBankFile() {
        if (this.mediaBankFile.$$uploadPogress) this.mediaBankFile.$$uploadPogress.abort();

        this.deleteFunction.emit();
    }

    editMediaBankFile() {
        this.editFunction.emit();
    }

    getPercentage() {
        return Math.floor((this.mediaBankFile.PercentageLoaded + this.mediaBankFile.PercentageProcessed) / 2);
    }

    getThumbUrl() {
        return this.mediaStorageService.getMediaFileUrl(this.mediaBankFile, { size: FiImageSize.Thumbnail });
    }
}
